import { AwsAccesses } from "@p0security/integrations-aws-shared/accesses";
import { Access, Delegate } from "@p0security/shared/types/access/index";

export const AwsRdsAccesses = {
  resource: Access({
    label: "Database",
    description: "Grant user access to database",
    delegation: {
      aws: Delegate({
        resource: "aws",
        accesses: AwsAccesses,
        key: "resource",
      }),
    },
    generated: {},
    maturity: "ga" as const,
    parameters: {
      arn: {
        type: "static",
        label: "Database ARN",
      },
      resourceId: {
        type: "static",
        label: "Database resource ID",
      },
      vpcId: {
        type: "static",
        label: "VPC ID",
      },
    },
    render: { locator: "vpcId" } as const,
  }),
};

export type AwsRdsAccesses = typeof AwsRdsAccesses;
